<template>
<div>
    <div class="card">
        <div class="card-header">
            <h3 class="card-title"> Search </h3>
            <div class="card-tools">
                <button class="btn btn-tool" @click.prevent="clear()"><i class="fa fa-eraser"></i></button>
            </div>
        </div>
        <div class="card-body table-responsive">
            <div class="row">
                <div class="form-group col-md-3">
                    <label>Websites</label>
                    <select id="website" name="website" class="form-control select2bs4">
                        <option selected hidden> -- Websites --</option>
                        <option v-for="website in websites" :key="website.id" :value="website.id" >
                            {{ website.name }} ({{ website.status | capitalize }})
                        </option>
                    </select>
                </div>
                <div class="form-group col-md-3">
                    <label>Groups</label>
                    <select id="group" class="form-control select2bs4" :disabled="!query.website">
                        <option selected disabled hidden> -- Groups -- </option>
                        <option v-for="group in groups" :key="group.id" :value="group.id" >
                            {{ group.name }} ({{ group.status | capitalize }})
                        </option>
                    </select>
                </div>
                <div class="form-group col-md-2">
                    <label>Type</label>
                    <select id="type" class="form-control select2bs4" :disabled="!query.group">
                        <option v-for="type in types" :key="type.id" :value="type.id" >
                            {{ type.name }}
                        </option>
                    </select>
                </div>
                <div class="form-group col-md-4">
                    <label>Data</label>
                    <select id="data" class="form-control select2bs4" multiple="multiple" :disabled="!query.type">
                        <option v-for="data in pg_data" :key="data.id" :value="data.id" >
                            {{ data.name }} ({{ data.status | capitalize }}) - {{ Supplier(data.supplier_id).name }}
                        </option>
                    </select>
                    <button @click="selectAllData()" class="float-right p-1 m-1">Select All</button> 
                    <button @click="clearSelectedData()" class="float-right p-1 m-1">Clear All</button> 
                </div>
                <div class="col-md-2">
                    <label>Status </label>
                    <div class="btn-group btn-group-toggle">
                        <label class="btn btn-default" :class="{'text-green': query.status == 'true'}">
                            <input type="radio" value="true" v-model="query.status"> Complete
                        </label>
                        <label class="btn btn-default" :class="{'text-warning': query.status == 'false'}">
                            <input type="radio" value="false" v-model="query.status"> Incomplete
                        </label>
                        <label class="btn btn-default" :class="{'text-blue': query.status == ''}">
                            <input type="radio" value="" v-model="query.status"> All
                        </label>
                    </div>
                </div>
                <div class="col-md-4"></div>
                <div class="form-group col-md-3">
                    <label>Date range:</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i class="far fa-calendar-alt"></i>
                            </span>
                        </div>
                        <input type="text" class="form-control float-right" id="daterange">
                  </div>
                </div>
                <div class="form-group col-md-1">
                    <label>Limit</label>
                    <select class="form-control" style="width: 100%;" v-model="query.limit">
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="30">30</option>
                    <option value="60">60</option>
                    <option selected value="100">100</option>
                    </select>
                </div>
                <div class="form-group col-md-1">
                    <label>Order</label>
                    <select class="form-control" style="width: 100%;" v-model="query.order">
                        <option selected="selected" value="-date">Newest</option>
                        <option value="date">Older</option>
                    </select>
                </div>
                <div class="form-group col-md-1">
                    <hr style="visibility: hidden;" />
                    <button class="btn btn-primary mr-2 mt-4"
                    @click.prevent="results()"><i class="fa fa-search"></i> </button>
                </div>

            </div>
        </div>
    </div>
    <StatisticsReports
        type="statistics"
        :search="query.search"
        :website="query.website"
        :group="query.group"
        :data="query.data"
        :full_data="full_data"
        :start_date="query.start_date" :end_date="query.end_date" :complete="query.status"
        :order="query.order" :limit="query.limit"
     />
</div>
</template>

<script>
import StatisticsReports from '@/components/analytics/statistics/Reports'
import { RepositoryFactory } from '@/services/repositories/ManagementAPI/RepositoryFactory';
const SuppliersRepo = RepositoryFactory.get('suppliers');
const PGDataRepo = RepositoryFactory.get('groups_data');
const WebsitesRepo = RepositoryFactory.get('websites');
const GroupsRepo = RepositoryFactory.get('groups');
const TypesRepo = RepositoryFactory.get('groups_types');

export default {
    components: {
        StatisticsReports
    },
    data() {
        return {
            suppliers: [],
            websites: [],
            groups: [],
            types: [],
            pg_data: [],
            selected_data: [],
            full_data: {},

            query: {
                supplier: 0,
                website: 0,
                group: 0,
                type: 0,
                data: 0,
                status: '',
                start_date: "",
                end_date: "",
                limit: 100,
                order: '-date',
                search: 0
            },
        }
    },
    created() {
        this.loadSuppliers()
        this.loadWebsites()
    },
    mounted() {
        // Initialize Select2 Elements
        $('.select2bs4').select2({
            theme: 'bootstrap4'
        })

        // Date range as a button
        var self = this
        function daterange(start, end) {
            self.query.start_date = start.format('YYYY-MM-DD')
            self.query.end_date = end.format('YYYY-MM-DD')
        }

        var startDate = this.$moment().subtract(29, 'days')
        var endDate = this.$moment()
        $('#daterange').daterangepicker({
                ranges   : {
                    'Today'       : [this.$moment(), this.$moment()],
                    'Yesterday'   : [this.$moment().subtract(1, 'days'), this.$moment().subtract(1, 'days')],
                    'Last 7 Days' : [this.$moment().subtract(6, 'days'), this.$moment()],
                    'Last 30 Days': [this.$moment().subtract(29, 'days'), this.$moment()],
                    'This Month'  : [this.$moment().startOf('month'), this.$moment().endOf('month')],
                    'Last Month'  : [this.$moment().subtract(1, 'month').startOf('month'), this.$moment().subtract(1, 'month').endOf('month')]
                },
                startDate: startDate,
                endDate  : endDate
            },
            daterange
        )
        daterange(startDate, endDate)
        
        var self = this
        $('#supplier').on("change", function(e) { 
            self.query.supplier = $(this).val()
        });
        $('#website').on("change", function(e) { 
            self.query.website = $(this).val()
        });
        
        $('#group').on("change", function(e) { 
            self.query.group = $(this).val()
        });

        $('#type').on("change", function(e) { 
            self.query.type = $(this).val()
        });

        $('#data').on("change", function(e) { 
            self.selected_data = $(this).val()
        });
    },
    methods: {
        loadWebsites: function() {
            WebsitesRepo.all().then(result => {
                this.websites = result.data.results
            }).catch(err => {})
        },
        loadSuppliers: function() {
            SuppliersRepo.all().then(result => {
                this.suppliers = result.data.results
            })
        },
        loadTypes() {
            TypesRepo.all().then(result => {
                this.types = result.data.results
            })
        },
        loadGroups: function(website) {
            GroupsRepo.withWebsite(website).then(result => {
                this.groups = result.data.results
            })
        },
        loadData: function(group, type) {
            PGDataRepo.withGroupAndType(group, type).then(result => {
                this.pg_data = result.data.results
            })
        },
        results: function() {
            this.full_data = {
                selected_data: this.selected_data,
                suppliers: this.suppliers,
                data: this.pg_data,
            }
            this.query.search += 1
        },
        clear: function() {
            this.query = {
                supplier: 0,
                website: 0,
                group: 0,
                data: 0,
                status: 0,
                start_date: "",
                end_date: "",
                limit: 30,
                order: '-date',
                search: 0
            }
        },
        Supplier(id) {
            let supplier = this.suppliers.filter(element => { return element.id == id })[0]
            if(supplier !== undefined)
                return supplier
        },
        selectAllData() {
            this.selected_data = this.filterIDList(this.pg_data, 'id')
            $('#data').val(this.selected_data).trigger("change")
        },
        clearSelectedData() {
            $('#data').val([]).trigger("change")
        }
    },
    watch: {
        "query.website": function(website) {
            if(website) {
                this.loadGroups(website)
            }
        },
        "query.group": function(group) {
            if(group) {
                this.loadTypes()
            }
        },
        "query.type": function(type) {
            if(type)
                this.loadData(this.query.group, type)
        },
        "selected_data": function(data) {
        }
    },
}
</script>